export const TOOLTIP_OFFSET = 12;
export const TOOLTIP_OFFSET_CS = 6;
